module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_is-object.js
// module id = 600
// module chunks = 0